<template>
  <v-dialog
    v-model="dialog"
    @input="(v) => v || closeDialog()"
    :persistent="persist"
    max-width="688px"
  >
    <v-card-text class="modal-header">
      <v-img
        v-if="!persist"
        @click="closeDialog"
        class="fixed-cancel-icon"
        src="../assets/icons/cancel.png"
        height="15px"
        width="15px"
      />
      <div>
        <h3>{{ dialogTitle }}</h3>
        <p class="my-1">{{ 'lng_box_detail_txt' | translate }}</p>
      </div>
    </v-card-text>
    <v-card class="d-flex justify-content-center">
      <v-card-text>
        <v-form class="ma-2 mt-3" ref="addBox" lazy-validation>
          <div class="fields-group my-5">
            <span class="group-title">{{
              'lng_sewer_box_txt' | translate
            }}</span>
            <!-- <v-img
              alt=""
              contain
              src="../assets/images/qr-code.png"
              transition="scale-transition"
              width="100"
              style="margin: 0 auto;"
            /> -->
            <div v-if="enableSewerQR">
              <p class="error">{{ qrError }}</p>
              <qrcode-stream @decode="onDecodeQR" @init="onCameraInit" />
            </div>
            <v-row class="justify-center">
              <v-col cols="12" sm="12" md="8">
                <div class="d-flex">
                  <span style="padding: 10px 5px 10px 0;"
                    >{{ 'lng_sewer_text' | translate }}-</span
                  >
                  <v-text-field
                    solo
                    :placeholder="'lng_sewer_id_txt' | translate"
                    type="text"
                    v-model="sewerId"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <span style="padding: 10px 5px 10px 5px;">-</span>
                  <v-text-field
                    solo
                    :placeholder="'lng_sewer_pass_txt' | translate"
                    type="text"
                    @click:append="showPass = !showPass"
                    v-model="sewerPass"
                    :rules="[rules.required]"
                  ></v-text-field>
                </div>
                <v-select
                  solo
                  class="mt-0 pt-0"
                  :items="sewerTypes"
                  :value="selectedSewerType"
                  item-text="name"
                  item-value="value"
                  menu-props="auto"
                  return-object
                  @change="
                    (value) => {
                      selectedSewerType = value;
                    }
                  "
                >
                  <template v-slot:selection="{ item, index }">
                    <span class="flags pl-2">{{ item.name | translate }}</span>
                  </template>
                  <template v-slot:item="{ item, index }">
                    <span class="flags pl-2">{{ item.name | translate }}</span>
                  </template>
                </v-select>
                <v-select
                  solo
                  class="mt-0 pt-0"
                  :items="equipmentTypes"
                  :value="selectedEquipmentType"
                  item-text="name"
                  item-value="value"
                  menu-props="auto"
                  return-object
                  @change="
                    (value) => {
                      selectedEquipmentType = value;
                    }
                  "
                >
                  <template v-slot:selection="{ item, index }">
                    <span class="flags pl-2">{{ item.name | translate }}</span>
                  </template>
                  <template v-slot:item="{ item, index }">
                    <span class="flags pl-2">{{ item.name | translate }}</span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="m-0 justify-end">
              <v-btn
                color="#0B7894"
                x-small
                dark
                @click="enableSewerQR = true"
                >{{ 'lng_scan_from_qr_txt' | translate }}</v-btn
              >
            </v-row>
            <!-- <v-text-field 
              :label="'lng_sewer_id_txt' | translate"
              type="text" v-model="sewerId" :rules="[rules.required]"></v-text-field>
            <v-text-field
              :label="'lng_sewer_pass_txt' | translate"
              type="text"
              @click:append="showPass = !showPass"
              v-model="sewerPass"
              :rules="[rules.required]"
            ></v-text-field> -->
          </div>
          <p class="warning-error mt-2" v-if="box2Error">{{ box2Error }}</p>
          <div class="fields-group my-5">
            <span class="group-title">{{
              'lng_house_box_txt' | translate
            }}</span>
            <div v-if="enableHouseQR">
              <p class="error">{{ qrError }}</p>
              <qrcode-stream @decode="onDecodeQR" @init="onCameraInit" />
            </div>
            <v-row class="justify-center">
              <v-col cols="12" sm="12" md="8">
                <div class="d-flex">
                  <span style="padding: 10px 5px 10px 0;"
                    >{{ 'lng_house_text' | translate }}-</span
                  >
                  <v-text-field
                    solo
                    :placeholder="'lng_house_id_txt' | translate"
                    type="text"
                    v-model="houseId"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <span style="padding: 10px 5px 10px 5px;">-</span>
                  <v-text-field
                    solo
                    :placeholder="'lng_house_pass_txt' | translate"
                    type="text"
                    @click:append="showPass = !showPass"
                    v-model="housePass"
                    :rules="[rules.required]"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row class="m-0 justify-end">
              <v-btn
                color="#0B7894"
                x-small
                dark
                @click="enableHouseQR = true"
                >{{ 'lng_scan_from_qr_txt' | translate }}</v-btn
              >
            </v-row>
            <!-- <v-text-field 
              :label="'lng_house_id_txt' | translate" 
              type="text" v-model="houseId" :rules="[rules.required]"></v-text-field>
            <v-text-field
              :label="'lng_house_pass_txt' | translate"
              type="text"
              @click:append="showPass = !showPass"
              v-model="housePass"
              :rules="[rules.required]"
            ></v-text-field> -->
          </div>
          <p class="warning-error mt-2" v-if="box1Error">{{ box1Error }}</p>
          <div class="fields-group my-5">
            <span class="group-title">{{
              'lng_alarm_options' | translate
            }}</span>
            <v-text-field
              :label="'lng_email_alarm_label' | translate"
              v-model="alarmEmail"
            ></v-text-field>
            <AlarmPhoneNumbers
              :alarmPhone="alarmPhone"
              @updatePhone="(phone, index) => onUpdatePhone(phone, index)"
            />
            <v-text-field
              :label="'lng_alarm_prefix_label' | translate"
              v-model="alarmPrefix"
              counter="15"
              maxlength="15"
            ></v-text-field>
          </div>

          <div class="fields-group my-5">
            <span class="group-title">{{
              'lng_service_settings' | translate
            }}</span>
            <v-text-field
              :label="'lng_service_settings_label' | translate"
              v-model="serviceEmail"
            ></v-text-field>
            <v-text-field
              :label="'lng_days_till_service' | translate"
              v-model="daysTillService"
              type="number"
            ></v-text-field>
            <v-text-field
              :label="'lng_note_txt' | translate"
              v-model="note"
            ></v-text-field>
          </div>

          <div class="fields-group my-5">
            <span class="group-title">{{
              'lng_operation_settings' | translate
            }}</span>
            <v-text-field
              :label="'lng_operation_settings_label' | translate"
              v-model="operationEmail"
            ></v-text-field>
          </div>

          <v-checkbox
            v-model="sameAddress"
            @change="changeAddressValues"
            :label="'lng_same_address_txt' | translate"
          ></v-checkbox>
          <div v-if="!sameAddress" class="fields-group my-5">
            <span class="group-title">{{ 'lng_th_address' | translate }}</span>
            <v-text-field
              :placeholder="'lng_address1_text' | translate"
              v-model="address1"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              :placeholder="'lng_address2_text' | translate"
              v-model="address2"
            ></v-text-field>
            <v-row>
              <v-text-field
                style="margin-right: 15px; margin-left: 15px;"
                :placeholder="'lng_zip_text' | translate"
                v-model="zip"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                style="margin-right: 15px; margin-left: 15px;"
                :placeholder="'lng_city_text' | translate"
                v-model="city"
                :rules="[rules.required]"
              ></v-text-field>
            </v-row>
            <v-select
              class="mt-0 pt-0"
              :items="countryItems"
              :value="selectedCountry.value"
              item-text="name"
              item-value="value"
              menu-props="auto"
              return-object
              @change="
                (value) => {
                  selectedCountry = value;
                }
              "
            ></v-select>
          </div>
          <p class="warning-error mt-2" v-if="error">{{ error }}</p>
          <div class="date-header d-flex justify-content-center py-5 mt-3">
            <v-btn
              v-if="logoutActive"
              color="grey"
              class="mx-2"
              dark
              @click="logoutAll"
              >{{ 'lng_logout_btn_txt' | translate }}</v-btn
            >
            <v-btn v-else color="grey" class="mx-2" dark @click="closeDialog">{{
              'lng_cancel_txt' | translate
            }}</v-btn>
            <v-btn
              color="#0B7894"
              dark
              @click="validate"
              :loading="showLoading"
              >{{ 'lng_save_box_txt' | translate }}</v-btn
            >
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  countries,
  sewerTypeValues,
  equipmentTypeValues,
} from '../common/Constant';
import UserService from '../services/user-service';
import router from '../router';
import { translateFunc } from '../common/Filters';
import VuePhoneNumberInput from 'vue-phone-number-input';
import { QrcodeStream } from 'vue-qrcode-reader';
import AlarmPhoneNumbers from './AlarmPhoneNumbers.vue';

export default {
  name: 'AddBoxModal',
  components: {
    VuePhoneNumberInput,
    QrcodeStream,
    AlarmPhoneNumbers,
  },
  data() {
    return {
      showPass: false,
      dialog: false,
      sameAddress: true,
      houseId: '',
      housePass: '',
      sewerId: '',
      sewerPass: '',
      address1: '',
      address2: '',
      city: '',
      zip: '',
      countryItems: countries,
      selectedCountry: {
        name: 'Denmark',
        value: 'DK',
      },
      rules: {
        required: (value) => !!value || translateFunc('lng_required_text'),
        counter: (value) =>
          value.length <= 20 || translateFunc('lng_required_length'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return (
            pattern.test(value) || translateFunc('lng_required_validate_email')
          );
        },
      },
      showLoading: false,
      error: '',
      box1Error: '',
      box2Error: '',
      alarmEmail: '',
      serviceEmail: '',
      daysTillService: '',
      note: '',
      operationEmail: '',
      alarmPrefix: '',
      alarmPhone: [''],
      phoneObject: [],
      translations: {
        countrySelectorLabel: translateFunc('lng_country_code_txt'),
        countrySelectorError: translateFunc('lng_country_code_error_txt'),
        phoneNumberLabel: translateFunc('lng_phone_alarm_label'),
        example: translateFunc('lng_example_text'),
      },
      sewerTypes: sewerTypeValues,
      selectedSewerType: {
        name: 'lng_other_txt',
        value: 'other',
      },
      equipmentTypes: equipmentTypeValues,
      selectedEquipmentType: {
        name: 'lng_other_txt',
        value: 'other',
      },
      qrError: '',
      result: '',
      enableSewerQR: false,
      enableHouseQR: false,
    };
  },
  props: {
    prefilledAddress: {
      type: Boolean,
      default: true,
    },
    persist: {
      type: Boolean,
      default: true,
    },
    openDialog: {
      type: Boolean,
      default: false,
    },
    closeDialog: {
      type: Function,
      default: undefined,
    },
    dialogTitle: {
      type: String,
      default: 'Dialog',
    },
    completeAddress: {
      type: Object,
      default: () => {},
    },
    userToken: {
      type: String,
      default: '',
    },
    logoutActive: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    },
    prefilledAddress: function(newVal) {
      this.sameAddress = newVal;
    },
    completeAddress: function(newVal) {
      this.address1 = newVal.addr1;
      this.address2 = newVal.addr2;
      this.city = newVal.city;
      this.zip = newVal.zip;
      this.selectedCountry = newVal.country;
    },
  },
  mounted() {
    this.sameAddress = this.prefilledAddress;
  },
  methods: {
    changeAddressValues() {
      if (this.sameAddress) {
        this.address1 = this.completeAddress.addr1;
        this.address2 = this.completeAddress.addr2;
        this.city = this.completeAddress.city;
        this.zip = this.completeAddress.zip;
        this.selectedCountry = this.completeAddress.country;
      } else {
        this.address1 = '';
        this.address2 = '';
        this.city = '';
        this.zip = '';
        this.selectedCountry = {
          name: 'Denmark',
          value: 'DK',
        };
      }
    },
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.addBox.validate()) {
          if (this.sameAddress) {
            this.saveBox('');
          } else {
            await this.getLatLng();
          }
        }
      });
    },
    async getLatLng() {
      let combinedAddress = `${this.address1} ${this.address2} ${this.city} ${this.zip} ${this.selectedCountry.name}`;
      let location = await UserService.googleApiForLatLng(combinedAddress);
      if (location.results.length) {
        await this.saveBox(location.results[0].geometry.location);
      } else {
        console.log('location not found');
        this.error = 'can not find city on the map';
      }
    },
    async saveBox(location) {
      this.error = '';
      (this.box1Error = ''), (this.box2Error = ''), (this.showLoading = true);
      let response;

      // if(!this.phoneObject.formattedNumber || (this.phoneObject.formattedNumber && this.phoneObject.isValid) ){
      let phoneNumbersArray = this.phoneObject
        .map((obj) =>
          obj.formattedNumber ? obj.formattedNumber.replace('+', '') : ''
        )
        .filter((num) => num);
      let phoneNumber = phoneNumbersArray.join(',');

      try {
        if (this.sameAddress) {
          response = await UserService.addBoxWithoutAddress(
            this.userToken,
            this.sewerId,
            this.sewerPass,
            this.houseId,
            this.housePass,
            this.alarmEmail,
            phoneNumber,
            this.alarmPrefix,
            this.selectedSewerType.value,
            this.selectedEquipmentType.value,
            this.serviceEmail,
            this.daysTillService,
            this.note,
            this.operationEmail
          );
        } else {
          response = await UserService.addBoxWithAddress(
            this.userToken,
            this.sewerId,
            this.sewerPass,
            this.houseId,
            this.housePass,
            this.address1,
            this.address2,
            this.city,
            this.zip,
            this.selectedCountry.name,
            location.lat,
            location.lng,
            this.alarmEmail,
            phoneNumber,
            this.alarmPrefix,
            this.selectedSewerType.value,
            this.selectedEquipmentType.value,
            this.serviceEmail,
            this.daysTillService,
            this.note,
            this.operationEmail
          );
        }
      } catch (e) {
        this.error = translateFunc('lng_try_again_txt');
        this.showLoading = false;
        console.log('e: ', e);
      }
      if (!response.status) {
        this.error = '';
        this.showLoading = false;
        // router.push(`/`);
        this.$emit('successAddingBox');
      } else {
        this.showLoading = false;
        if (response.status == 1) {
          this.box1Error = response.msg;
        } else if (response.status == 2) {
          this.box2Error = response.msg;
        } else this.error = response.msg;
      }
      // }
    },
    onUpdatePhone(payload, index) {
      if (index <= this.phoneObject.length - 1)
        this.phoneObject[index] = payload;
      else this.phoneObject.push(payload);
    },
    onDecodeQR(result) {
      if (result) {
        let data = result.split('-');
        if (data[0] === 'broend') {
          this.sewerId = data[1];
          this.sewerPass = data[2];
        } else if (data[0] === 'hus') {
          this.houseId = data[1];
          this.housePass = data[2];
        }
        this.enableSewerQR = false;
        this.enableHouseQR = false;
      }
    },
    async onCameraInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.qrError = 'ERROR: you need to grant camera access permisson';
        } else if (error.name === 'NotFoundError') {
          this.qrError = 'ERROR: no camera on this device';
        } else if (error.name === 'NotSupportedError') {
          this.qrError = 'ERROR: secure context required (HTTPS, localhost)';
        } else if (error.name === 'NotReadableError') {
          this.qrError = 'ERROR: is the camera already in use?';
        } else if (error.name === 'OverconstrainedError') {
          this.qrError = 'ERROR: installed cameras are not suitable';
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.qrError = 'ERROR: Stream API is not supported in this browser';
        }
      }
    },
    logoutAll() {
      let myItem = localStorage.getItem('vue-cookie-accept-decline-myPanel1');
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem('vue-cookie-accept-decline-myPanel1', myItem);
      router.push('/login');
    },
  },
};
</script>
<style scoped>
/* .close-btn {
  color: rgba(0, 0, 0, 0.87);
} */
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 95%;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
}
.fixed-cancel-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
</style>
<style>
.v-input__slot {
  min-height: 30px !important;
}
.modal-header {
  position: sticky; 
  top: 0;
  width: 100% !important;
  background: #fff;
  z-index: 9;
  padding: 0 1rem;
}
</style>
